module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0052.jpg?v=4c73bad5";